@if(!collapsible()){
<ul
  class="nav-list"
  [ngClass]="{
    'navbar-expand': show()
  }"
>
  @for (item of menuList(); track item.id) {
    <li class="nav-list__item">
      <a [routerLink]="[item.urlPath]"
         routerLinkActive="active-link"
         [routerLinkActiveOptions]="{exact: true}"
         class="nav-list__link"
         (click)="closeMenu()"
      >{{ item.title | translate }}</a>
    </li>
  }
</ul>
} @else {
  <ul class="nav-list-collapsible"
      [ngClass]="{
    'navbar-expand': show()
  }">
    <li class="nav-list__item display-md-block mb-12">
      @if (account.isLoggedIn()) {
        <button class="nav-list__logout-button" type="button" (click)="showLogoutDialog()">
          <span>{{ 'logout' | translate }}</span>
          <img ngSrc="/images/icons/arrows/logout-black.svg" width="24" height="24" alt="">
        </button>
      }
    </li>
    @for(item of menuList(); track item.id){
      <li class="nav-list-collapsible__item">
        <a [routerLink]="[item.urlPath]"
           routerLinkActive="active-link"
           [routerLinkActiveOptions]="{exact: true}"
           class="nav-list-collapsible__button"
           (click)="closeMenu()"
        >{{ item.title | translate }}</a>
      </li>
    }
  </ul>
}
